import * as React from "react";
import type { SVGProps } from "react";
const SvgSun01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M18.857 20.2a1 1 0 1 0 0-2v2m-13.714-2a1 1 0 1 0 0 2v-2M2.4 13.902a1 1 0 1 0 0 2v-2m19.2 2a1 1 0 1 0 0-2v2M4.245 12.048a1 1 0 1 0 1.11-1.664l-.555.832zm-.948-3.035a1 1 0 1 0-1.109 1.664l.555-.832zM8.104 7.46a1 1 0 0 0 1.792-.887L9 7.016zM8.8 4.357a1 1 0 0 0-1.792.886l.896-.443zm4.99 1.945a1 1 0 0 0 1.665 1.11l-.832-.555zm3.036-.947a1 1 0 1 0-1.664-1.11l.832.555zm4.976 5.386a1 1 0 0 0-.886-1.793l.443.897zm-3.102-.697a1 1 0 0 0 .886 1.793l-.443-.896zm.157 9.156v-1H5.143v2h13.714zM2.4 14.902v1h19.2v-2H2.4zm4.8 0h1a3.8 3.8 0 0 1 3.8-3.8v-2a5.8 5.8 0 0 0-5.8 5.8zm4.8-4.8v1a3.8 3.8 0 0 1 3.8 3.8h2a5.8 5.8 0 0 0-5.8-5.8zm-7.2 1.114.555-.832-2.058-1.371-.554.832-.555.832 2.057 1.371zm4.2-4.2.896-.443L8.8 4.357l-.896.443-.896.443L8.104 7.46zm5.623-.159.832.555 1.371-2.057-.832-.555-.832-.555-1.371 2.057zm6.736 2.988-.443-.897-2.216 1.096.443.897.443.896 2.217-1.096z"
    />
  </svg>
);
export default SvgSun01;
